import { WorkExperience } from '../types';

export const experience: WorkExperience[] = [
  {
    title: 'Platform DevOps Engineer',
    company: 'Ticketmaster / Moshtix',
    period: 'November 2023 - Present',
    description: 'Developed and implemented automation tools for building, testing, provisioning, and monitoring, significantly enhancing efficiency, reducing deployment times, and cutting infrastructure costs. Designed and implemented cloud infrastructure on AWS utilizing services such as Lambda, API Gateway, S3, CloudFront, VPC, EC2, and DynamoDB. Developed and maintained CI/CD pipelines using GitHub Actions, with a focus on improving developer experience and streamlining technical processes. Implemented and maintained security measures including PCI compliance requirements, working with AWS GuardDuty, SecurityHub, and CloudTrail. Built cloud infrastructure as code using AWS CDK with TypeScript and Serverless Framework.',
  },
  {
    title: 'DevOps Engineer (Contractor)',
    company: 'MYOB (Auckland - New Zealand)',
    period: '2021 - 2022',
    description: 'I became part of an Australian company and was employed as a DevOps engineer, utilizing the following technologies: React.js, Node.js, TypeScript, Docker, K8s, and AWS.',
  },
  {
    title: 'Senior Software Engineer / Technical Lead',
    company: 'Traffic New Zealand Ltd. (Auckland)',
    period: '2016 - 2021',
    description: 'I became part of a Kiwi company and was employed as a Senior Software Engineer and Technical Leader. In this role, I utilized the following technologies: Node.js, Angular, TypeScript, and AWS.',
  },
  {
    title: 'System Integration Analyst Programmer',
    company: 'FAB Group NZ (Auckland - New Zealand)',
    period: '2015 - 2016',
    description: 'I provided technical expertise to ensure that all FAB Group IS data flows, integrations, and applications operate at an optimum level, perform smoothly, and resolve issues quickly. In order to accomplish this, I utilized the following technologies: Pentaho, Node.js, Python, and Java.',
  },
  {
    title: 'Application Development and QA Analyst',
    company: 'The University of Auckland (New Zealand)',
    period: '2014 - 2016',
    description: 'As part of the QA team, I helped test the UoA web applications based on the Adobe Enterprise Manager. These tests included manual testing, responsive testing, compatibility testing, performance testing, E2E testing, and also developing automated testing utilizing the following technologies: JMeter, Node.js, and Angular.',
  },
  {
    title: 'Senior Java / Oracle Developer',
    company: 'Transactor Technologies (Auckland - New Zealand)',
    period: '2012 - 2014',
    description: 'I became part of a Kiwi company and was employed as a Java/Oracle developer. In this role, I worked as a Java and web developer, as well as a functional and technical analyst, utilising Java and Oracle.',
  },
  {
    title: 'Senior Software Engineer / Architect / Technical Leader',
    company: 'Capgemini SLU (Madrid - Spain)',
    period: '2005 - 2011',
    description: 'I became part of a French IT company and was employed as a Software Engineer. I worked as an architect, Java developer, and technical leader, using Java and Oracle, among other technologies.',
  },
  {
    title: 'Programming Analyst',
    company: 'Builder Informática SA / Fomento De Constucciones y Contratas (Madrid - Spain)',
    period: '2003 - 2005',
    description: 'I became part of a Spanish IT company and was employed as a Software Engineer. I worked as an Analyst Developer using PowerBuilder and Informix.',
  },
  {
    title: 'Help Desk / Programmer / Consultant',
    company: 'Southern Star - Hewlett-Packard (Madrid - Spain)',
    period: '2000 - 2003',
    description: 'I worked in the vendor environment as a Help Desk Operator/Programmer/Consultant with health applications (HP-HIS, Health Information System), using PowerBuilder, Informix, Sybase, and Oracle.',
  },
];
